import { Typography, Box, Button, Theme, SxProps } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { BaseModal } from './BaseModal/BaseModal';
import { TInfoModal } from '~/modules/identification/types';
import { Close } from '@mui/icons-material';

type TStyles = {
  paper: SxProps<Theme>;
  closeButton: SxProps<Theme>;
  groupButton: SxProps<Theme>;
};

const styles: TStyles = {
  paper: {
    padding: 3,
    gap: 2.5,
    position: 'relative',
  },
  closeButton: (theme: Theme) => ({
    position: 'absolute',
    cursor: 'pointer',
    color: theme.palette.common.black,
    top: theme.spacing(0.5),
    right: theme.spacing(1),
  }),
  groupButton: (theme: Theme) => ({
    display: 'flex',
    gap: theme.spacing(2),
  }),
};

export const InfoModal = ({
  isOpened,
  isDisabledOutsideClickClose,
  title,
  message,
  onClose,
  primaryButtonTitle,
  secondaryButtonTitle,
  onSecondaryButtonClick,
  onPrimaryButtonClick,
}: TInfoModal) => {
  return (
    <BaseModal
      open={isOpened}
      onClose={isDisabledOutsideClickClose ? undefined : onClose}
      containerProps={{ sx: styles.paper }}
    >
      <IconButton sx={styles.closeButton} onClick={onClose}>
        <Close />
      </IconButton>
      {title && (
        <Typography variant="h4" sx={{ textAlign: 'center' }}>
          {title}
        </Typography>
      )}
      {message && (
        <Typography variant="body1" sx={{ textAlign: 'center' }}>
          {message}
        </Typography>
      )}
      <Box sx={styles.groupButton}>
        <Button variant="contained" sx={{ minWidth: 160 }} onClick={() => onPrimaryButtonClick?.()}>
          {primaryButtonTitle}
        </Button>
        {!!secondaryButtonTitle && (
          <Button
            variant="outlined"
            sx={{ minWidth: 160 }}
            onClick={() => onSecondaryButtonClick?.()}
          >
            {secondaryButtonTitle}
          </Button>
        )}
      </Box>
    </BaseModal>
  );
};
